import React, { Component } from "react";
import { Field } from "redux-form";
import { bindActionCreators } from "redux";
import {
	TextField,
	SelectField as RFSelectField,
	DatePicker,
	RadioButtonGroup
} from "redux-form-material-ui";
import { connect } from "react-redux";
import _ from "lodash";
import { MenuItem, RadioButton } from "material-ui";
import { actionGetCities } from "../../../actions/ProvinceActions";
import { validateEmail, noUnderscore } from "../../../common/validaciones";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../../actions/ActionConstants";
import { AFILIADOS } from "../../../config/RoutesConstants";
import Util from "../../../common/Util";
import UtilPC from "../../../common/UtilPC";
import VerticalListFields from "../../../components/VerticalListFields/VerticalListFields";
import InputMask from "../../../components/InputMask/InputMask";
import { ROL_OPERADOR_RECAUDA } from "../../../common/Constants";

class MembershipTab extends Component {
	constructor(props) {
		super(props);
		let state =
			this.props.modeCRU === MODE_CRU_CREATE
				? this.returnStateNewAfiliado()
				: this.props.modeCRU === MODE_CRU_UPDATE
					? this.returnStateEditAfiliado()
					: this.returnStateShowAfiliado();
		this.state = state;
	}

	componentWillMount() {
		if (!this.props.modeCRU) {
			this.props.history.push(AFILIADOS);
		}
	}

	returnStateShowAfiliado() {
		const state = {
			enableField: true,
			province: null
		};
		return state;
	}

	returnStateNewAfiliado() {
		return { disableCity: true, province: null };
	}

	returnStateEditAfiliado() {
		return { disabledCity: false, province: null };
	}

	render() {
		const disabled =
			this.props.rol === ROL_OPERADOR_RECAUDA ||
			this.props.modeCRU === MODE_CRU_SHOW;
		return (
			<div className="center">
				<VerticalListFields
					titleText="Datos de Afiliación"
					titleClass="title-papercard-primary"
					paperClass="papercard top10 bottom20"
					contentClass="content-papercard-row-center padding20"
				>
					<div className="columns-column-between columns-half bottom25">
						<Field
							name="person.birthdate"
							component={DatePicker}
							floatingLabelText="Fecha de nacimiento"
							format={Util.isoDateToJavascriptDate}
							DateTimeFormat={Intl.DateTimeFormat}
							locale="es-ES"
							maxDate={new Date()}
							parse={v => Util.formatDateToISODate(v)}
							fullWidth
							disabled={disabled}
						/>
						<Field
							name="person.gender.id"
							component={RFSelectField}
							floatingLabelText="Sexo"
							fullWidth
							disabled={disabled}
						>
							{UtilPC.renderSelectFieldItemsArray(this.props.gendersList)}
						</Field>
						<Field
							name="person.nationality.id"
							component={RFSelectField}
							floatingLabelText="Nacionalidad"
							fullWidth
							disabled={disabled}
						>
							{UtilPC.renderSelectFieldItemsArray(this.props.nationalitiesList)}
						</Field>
						<Field
							name="person.civilStatus.id"
							component={RFSelectField}
							floatingLabelText="Estado civil"
							fullWidth
							disabled={disabled}
						>
							{UtilPC.renderSelectFieldItemsArray(this.props.civilStatusList)}
						</Field>
						<Field
							name="person.documentNumber"
							component={InputMask}
							validate={noUnderscore}
							floatingLabelText="Nro. de documento"
							mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
							floatingLabelFixed={this.props.modeCRU !== MODE_CRU_CREATE}
							fullWidth
							disabled={disabled}
						/>
						<Field
							name="person.email"
							component={TextField}
							floatingLabelText="Email"
							validate={validateEmail}
							fullWidth
							disabled={disabled}
						/>
						<Field
							name="person.profession"
							component={TextField}
							floatingLabelText="Profesión"
							fullWidth
							disabled={disabled}
						/>
						<Field
							name="person.speciality"
							component={TextField}
							floatingLabelText="Especialidad"
							fullWidth
							disabled={disabled}
						/>
					</div>
					<div className="columns-column-between columns-half bottom25 right20 left20">
						<div className="columns-column-simple ">
							<Field
								name="person.streetName"
								component={TextField}
								floatingLabelText="Calle"
								fullWidth
								disabled={disabled}
							/>
						</div>
						<div className="columns-column-simple">
							<Field
								name="person.streetNumber"
								component={TextField}
								floatingLabelText="Nro."
								disabled={disabled}
							/>
							<Field
								name="person.floor"
								component={TextField}
								floatingLabelText="Piso"
								className={"left10"}
								disabled={disabled}
							/>
							<Field
								name="person.department"
								component={TextField}
								floatingLabelText="Depto"
								className={"left10"}
								disabled={disabled}
							/>
							<Field
								name="person.postalCode"
								component={TextField}
								floatingLabelText="Codigo Postal"
								className={"left20"}
								disabled={disabled}
							/>
						</div>
						<div className="columns-column-simple ">
							<Field
								name="person.city.province.id"
								component={RFSelectField}
								floatingLabelText="Provincia"
								fullWidth
								disabled={disabled}
								onChange={(event, value) => {
									this.setState({ disableCity: false });
									this.props.actionGetCities(value);
								}}
							>
								{_.map(this.props.provinciasList, (provincia, i) => {
									return (
										<MenuItem
											key={i + 1}
											value={provincia.id}
											primaryText={provincia.name}
										/>
									);
								})}
							</Field>
						</div>
						<div className="columns-column-simple ">
							<Field
								name="person.city.id"
								component={RFSelectField}
								floatingLabelText="Localidad"
								fullWidth
								disabled={this.state.disableCity ? true : disabled}
							>
								{_.map(this.props.cityList, (city, i) => {
									return (
										<MenuItem
											key={i + 1}
											value={city.id}
											primaryText={city.name}
										/>
									);
								})}
							</Field>
						</div>
						<div className="columns-column-simple ">
							<Field
								name="person.telephoneNumber"
								component={TextField}
								floatingLabelText="Teléfono"
								disabled={disabled}
							/>
							<Field
								name="person.mobileNumber"
								component={TextField}
								floatingLabelText="Celular"
								className={"left20"}
								disabled={disabled}
							/>
						</div>
						<div className="rows-column-around">
							<p>¿Es propietario?</p>
							<Field
								name="person.isOwner"
								component={RadioButtonGroup}
								format={v =>
									v === true ? "true" : v === false ? "false" : null}
								parse={v => v === "true"}
								disabled={disabled}
							>
								<RadioButton value="true" label="Si" disabled={disabled} />
								<RadioButton value="false" label="No" disabled={disabled} />
							</Field>
						</div>
						<div className="columns-column-simple ">
							<Field
								name="person.medicalInsurance"
								component={TextField}
								floatingLabelText="Obra social"
								fullWidth
								disabled={disabled}
							/>
						</div>
						<div className="rows-column-around ">
							<p>¿Es donante?</p>
							<Field
								name="person.isDonor"
								component={RadioButtonGroup}
								format={v =>
									v === true ? "true" : v === false ? "false" : null}
								parse={v => v === "true"}
								disabled={disabled}
							>
								<RadioButton value="true" label="Si" disabled={disabled} />
								<RadioButton value="false" label="No" disabled={disabled} />
							</Field>
						</div>
						<div className="columns-column-simple">
							<Field
								name="person.bloodType"
								component={RFSelectField}
								floatingLabelText="Grupo sanguíneo"
								disabled={disabled}
							>
								<MenuItem value="A" key={1} primaryText="A" />
								<MenuItem value="B" key={2} primaryText="B" />
								<MenuItem value="AB" key={3} primaryText="AB" />
								<MenuItem value="O" key={4} primaryText="O" />
							</Field>
							<Field
								name="person.bloodFactor"
								component={RFSelectField}
								floatingLabelText="Factor"
								className={"left20"}
								disabled={disabled}
							>
								<MenuItem value="POSITIVO" key={1} primaryText="Positivo" />
								<MenuItem value="NEGATIVO" key={2} primaryText="Negativo" />
							</Field>
						</div>
					</div>
				</VerticalListFields>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		afiliado: store.afiliado.afiliado,
		provinciasList: store.locations.provinciasList,
		cityList: store.locations.ciudadesList,
		modeCRU: store.afiliado.modeCRU,
		civilStatusList: store.data.civilStatusList,
		gendersList: store.data.gendersList,
		nationalitiesList: store.data.nationalitiesList,
		rol: store.app.rol
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionGetCities
		},
		dispatch
	);
}
export default connect(mapStateToProps, mapDispatchToProps)(MembershipTab);



// WEBPACK FOOTER //
// ./src/screens/Afiliado/Tabs/PersonalTab.js